import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { callAPI } from "../../../../../axios";
import { getMasterPermissions } from "../../../../../store/actions/PersmissionActions/PersmissionActions";
import { Grid } from "@mui/material";
import Controls from "../../../../core/Controls/Controls";
import AddPermission from "../AddPermission/AddPermission";
import PermissionBlock from "../PermissionBlock/PermissionBlock";
import AddIcon from "@mui/icons-material/Add";
import { isValidRole } from "../../../../../utils/utils";
import { Link, useLocation } from "react-router-dom";
import BasicModal from "../../../../core/BaseComponents/Modal";

const RoleAndPermission = (props) => {
  const location = useLocation();
  const [addPermission, setAddPermission] = useState(false);
  const [error, setError] = useState("");
  const [selectedModule, setSelectedModule] = useState(0);
  const [userList, setUserList] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [roleInfo, setRoleInfo] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [userPermissionSuccess, setUserPermissionSuccess] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState(location?.state?.roleSelected);
  const [flag, setFlag] = useState(false);
  const [selectRoles, setSelectRoles] = useState(false);
  let validPermissionClassName = isValidRole("EDIT_PERMISSIONS")
    ? "cursor-pointer"
    : "actionButtonDisable";
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userRole = 'Super Admin';
  // const userRole = userDetails?.roles[0].roleCode;
  
  const populateGridData = (userList) => {
    let rows = [];
    if (userList !== undefined && userList !== "") {
      userList.forEach((u) => {
        rows.push({ ...u, id: u.sid, title: u.name });
      });
    }
    setUserList(rows);
  };

  const getUserList = () => {
    const apiPath = `/master?type=ROLES`;
    callAPI(apiPath, "GET")
      .then((res) => {
        const data = res.data;
        populateGridData(data);
      })
      .catch((err) => {
        console.warn(err.message);
      })
      .finally((_) => { });
  };

  const getUserRole = () => {
    const apiPath = `/role/permission?roleSid=${user}`;
    // api.get(apiPath)
    callAPI(apiPath, "GET")
      .then((res) => {
        // console.log("getuserole",res)
        setRoleInfo(res);
      })
      .catch((err) => {
        console.warn(err.message);
      })
      .finally((_) => { });
  };

  const addPermissionHandler = (args) => {
    const temp = { ...selectedPermissions };
    if (
      args.selectedPermission &&
      args.selectedPermission.some((x) => x.checked == true)
    ) {
      temp[args.module] = args;
    } else {
      delete temp[args.module];
    }
    setUserInfo({
      ...userInfo,
      tempPermissions: temp,
    });
    setSelectedPermissions(temp);
  };

  const showPermissionModal = () => {
    if (user) {
      setSelectedModule(0);
      setAddPermission(true);
    } else {
      setError("Please Select Role");
    }
  };

  const updatePermissionHandler = (item) => {
    setFlag(true);
    setSelectedModule(item.module);
    setAddPermission(true);
  };

  const deletePermissionHandler = (item) => {
    const temp = { ...selectedPermissions };
    delete temp[item.module];
    setSelectedPermissions(temp);
  };

  const resetData = () => {
    setUser(0);
    setSelectedPermissions({});
    getUserList();
  };

  const saveData = () => {
    const userSid = user;
    const permissionSids = [];
    Object.keys(selectedPermissions).forEach((moduleId) => {
      selectedPermissions[moduleId].selectedPermission.forEach((per) => {
        if (per.checked) {
          permissionSids.push(per.id);
        }
      });
    });
    if (userSid === 0) {
      //   toast(<Toaster msgType={'error'} message='Please select User' />);
    } else {
      const apiPath = `/role/permission`;
      callAPI(apiPath, "PUT", {
        roleSid: userSid,
        permissionSids: permissionSids,
      })
        .then((res) => {
          setShowPopup(true);
          setUserPermissionSuccess(res.message);
          // resetData();
        })
        .catch((err) => {
          console.warn(err)
        })
        .finally((_) => { });
    }
  };

  useEffect(() => {
    const userInfo = userList.find((u) => u.sid === user);
    const tempPermissions = {};
    if (userInfo) {
      const savedPermissions = roleInfo.permissions;
      savedPermissions.forEach((sp) => {
        if (tempPermissions[sp.parentPermissionSid] === undefined) {
          tempPermissions[sp.parentPermissionSid] = {};
          tempPermissions[sp.parentPermissionSid].module =
            sp.parentPermissionSid;
          tempPermissions[sp.parentPermissionSid].selectedPermission = [];
        }
        tempPermissions[sp.parentPermissionSid].selectedPermission.push({
          ...sp,
          checked: true,
          title: sp.permission,
        });
      });
    }
    setSelectedPermissions(tempPermissions);
    setUserInfo({
      ...userInfo,
      tempPermissions: tempPermissions,
    });
  }, [roleInfo]);

  useEffect(() => {
    props.getMasterPermissions();
    getUserList();
    if (user) {
      getUserRole();
    }
  }, [user]);

  const closePopupHandler = () => {
    setShowPopup(false);
    setUserPermissionSuccess(null);
  };

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &#62; </span>
          </li>
          <li>Role & Permission</li>
        </ul>
      </div>
      <div className="sub-header">
        <h1>Role & Permission</h1>
      </div>
      <div className="roles-and-permission">
        <div className="d-flex justify-content-between">
          <div className="position-relative">
            <label className="d-block">Roles</label>
            <Controls.Select
              className={"control-select position-relative customdropdown"}
              name={"userrolesandpermissions"}
              value={user}
              items={userList}
              optionDisabledProp={userRole}
              placeholder="Please Select Role"
              onChange={(e) => {
                setUser(e.target.value);
                e.target.value !== 0 && setError("");
                setSelectRoles(true);
              }}
              error={error}
            />
            {/* <span className="pe-7s-angle-down rolesdown"></span> */}
            {/* {!selectRoles && <p className="">Please Select Role</p>} */}
          </div>
          <div className="align-self-end">
            <div className={`createuser ${validPermissionClassName}`}>
              <span
                className="cursor-pointer"
                onClick={
                  isValidRole("EDIT_PERMISSIONS") ? showPermissionModal : null
                }
              >
                <AddIcon className="add-icon-style" />
                Add Permission
              </span>
            </div>
          </div>
        </div>
        {user > 0 && (
          <>
            <Grid item xs={12} className="permission-list px-0">
              <PermissionBlock
                items={selectedPermissions}
                updateHandler={updatePermissionHandler}
                deleteHandler={deletePermissionHandler}
              />
            </Grid>
            <div className="d-flex justify-content-end mb-0 pop-btns mt-3">
              <button
                onClick={resetData}
                size="small"
                type="submit"
                className="reset-btn me-3"
              >
                Reset
              </button>
              <button
                onClick={isValidRole("EDIT_PERMISSIONS") ? saveData : null}
                size="small"
                type="submit"
                className={`create-btn ${validPermissionClassName}`}
              >
                Update
              </button>
            </div>
          </>
        )}

        <BasicModal
          popupOpen={showPopup}
          bodyMessage={<>
            {userPermissionSuccess && (
              <span className="d-block">
                <img src="/Images/approve-qc.png" alt="approve" style={{ width: 60 }} />
                <p className="mt-2">{userPermissionSuccess}</p>
              </span>
            )}
          </>
          }
          footer={
            {
              secondaryButton: {
                buttonName: "OK",
                action: closePopupHandler
              }
            }
          }
        />
      </div>
      {addPermission && (
        <AddPermission
          edit={flag}
          open={addPermission}
          closeHandler={() => {
            setAddPermission(false);
            setFlag(false);
          }}
          onClickHandler={addPermissionHandler}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          selectedPermissions={selectedPermissions}
          user={user}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.permissionReducer.permissions,
  };
};

const mapDispatcherToProps = (dispatch) => {
  return {
    getMasterPermissions: () => dispatch(getMasterPermissions()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatcherToProps
)(RoleAndPermission);
